export default {
  'menu.welcome': 'Workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.dashboard.comicRankings': 'Comic Rankings',
  'menu.dashboard.packageMetrics': 'Package Metrics',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.tags': 'Tags',
  'menu.tags.source': 'Tags',
  'menu.tags.master': 'Master Tags',
  'menu.tags.translations': 'Tag Translations',
  'menu.comics': 'Comics',
  'menu.comics.list': 'Comic List',
  'menu.comics.recommended': 'Home Recommended',
  'menu.comics.works': 'Comic Works',
  'menu.comics.exports': 'Export Tasks',
  'menu.comics.reportAnalysis': 'Report Analysis',
  'menu.comics.retentionAnalysis': 'Retention Analysis',
  'menu.comics.spiderSync': 'Spider Sync',
  'menu.comics.create': 'Create Comic',
  'menu.comics.edit': 'Edit Comic',
  'menu.comics.chapters': 'Chapters',
  'menu.comics.chapterEdit': 'Edit Chapter',
  'menu.logs': 'App Users',
  'menu.logs.blacklist': 'App Users',
  'menu.logs.blackRecords': 'Blacklist Records',
  'menu.logs.searchRecords': 'Search Records',
  'menu.logs.comicPushDeliveries': 'Comic Push Records',
  'menu.logs.whitelist': 'Whitelist',
  'menu.logs.userPolicies': 'User Policies',
  'menu.logs.userPolicyHits': 'Policy Hits',
  'menu.versionManagement': 'Version Management',
  'menu.versionManagement.version': 'Version Management',
  'menu.versionManagement.ips': 'IP Management',
  'menu.versionManagement.packages': 'Package Management',
  'menu.growthConfig': 'Growth Config',
  'menu.growthConfig.adConfig': 'Ad Configuration',
  'menu.growthConfig.adConfig.adManagement': 'Ad Management',
  'menu.growthConfig.adConfig.adManagement.adSlotsConfig': 'Ad Groups',
  'menu.growthConfig.adConfig.adManagement.adGlobalConfigs':
    'Global Ad Configuration',
  'menu.growthConfig.adConfig.adIds': 'Ad ID Management',
  'menu.growthConfig.adConfig.adTypes': 'Ad Types',
  'menu.growthConfig.adConfig.adSlotPositions': 'Ad Positions',
  'menu.growthConfig.adConfig.adClientPositions': 'Client Positions',
  'menu.growthConfig.adConfig.adSlotPlacementSettings': 'Ad Position Settings',
  'menu.growthConfig.adExperiments': 'A/B Testing',
  'menu.growthConfig.homeGuide': 'Home Guide',
  'menu.growthConfig.appDecor': 'App Decor Management',
  'menu.growthConfig.appDecor.profiles': 'App Decor Profiles',
  'menu.growthConfig.appDecor.pools': 'Comic Pools',
  'menu.growthConfig.appDecor.comicLists': 'Comic Lists',
  'menu.growthConfig.appDecorProfiles': 'App Decor Profiles',
  'menu.growthConfig.feedbacks': 'Feedback',
  'menu.growthConfig.feedbacks.settings': 'Settings Feedback',
  'menu.growthConfig.feedbacks.readerUser': 'Reader Feedback',
  'menu.growthConfig.feedbacks.summary': 'Comic Feedback Summary',
  'menu.growthConfig.namespaces': 'Namespaces',
  'menu.configManagement': 'Global Config',
  'menu.configManagement.featureFlags': 'Feature Flag',
  'menu.configManagement.lab': 'Lab',
  'menu.system': 'System',
  'menu.maintenance': 'Maintenance',
  'menu.maintenance.readerBugs': 'BUG Management',
  'menu.system.users': 'Admin Users',
  'menu.system.groups': 'Groups',
  'menu.system.permissions': 'Permissions',
  'menu.system.actionLogs': 'Audit Logs',
  'menu.system.flower': 'Task Monitor',
  'menu.system.cache': 'Cache Management',
  'menu.system.encryptedDomains': 'Encrypted Domains',
  'menu.system.policyGatewayTestRoutes': 'Policy Gateway Test Routes',
  'menu.system.notificationBridge': 'Notification Bridge',
};
